import { Box, Divider, Flex, IconButton, Input, Text } from '@chakra-ui/react'
import { useState } from 'react'
import { FaArrowLeft } from 'react-icons/fa'
import { useMutation, useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { DiaryService } from 'service'

export function DiaryHeader({
  setSearch,
}: {
  setSearch?: (word: string) => void
}) {
  const { id } = useParams()
  const [total, setTotal] = useState(0)
  const [remain, setRemain] = useState(0)
  const [searchWord, setSearchWord] = useState('')

  const enterSearch = () => {
    if (setSearch) {
      setSearch(searchWord)
    }
  }

  useQuery(
    ['getRemainDiary'],
    async () => await DiaryService.getCountWaiting(),
    {
      onSuccess: (data) => {
        setRemain(data)
      },
    },
  )
  useQuery(
    ['getDiaryTotal'],
    async () => {
      return await DiaryService.getCount()
    },
    {
      onSuccess: (data) => {
        setTotal(data)
      },
    },
  )

  const cancleAnswer = useMutation(['cancelAnswer', id], async () => {
    return await DiaryService.cancelAnswer(Number(id))
  })

  return (
    <>
      <Flex align="center" justify="space-between">
        <Box>
          {id && (
            <IconButton
              bg="transparent"
              icon={<FaArrowLeft />}
              aria-label="back"
              onClick={() => {
                cancleAnswer.mutate()
                history.back()
              }}
            />
          )}
          <Text as="h4" fontWeight="bold" display="inline" mr={2}>
            전체 마음일기
          </Text>
          <Text as="span">
            <Text as="span" color="green">
              {remain}
            </Text>
            / {total}
          </Text>
        </Box>
        {setSearch && (
          <Input
            w="40%"
            placeholder="검색"
            focusBorderColor="darkblue"
            value={searchWord}
            onChange={(e) => {
              e.preventDefault()
              setSearchWord(e.target.value)
            }}
            onKeyDown={(e) => {
              if (e.code === 'Enter') {
                enterSearch()
              }
            }}
          />
        )}
      </Flex>
      <Divider borderColor="gray" my={4} />
    </>
  )
}
